module.exports = __webpack_public_path__ + "static/media/FieldService.4ddaeebd.svg";